module.exports = __webpack_public_path__ + "img/orders.97f40f90.svg";